import { Button } from "@/components/UI/Button";
import tradeBlockDataStore from "@/store/tradeBlockDataStore";
import { getBlocksData } from "@/store/tradeBlockDataStoreACTIONS";
import tradeSettingsStore from "@/store/tradeSettingsStore";
import {
  clearAllActiveCounterparties,
  setActiveToggle,
} from "@/store/tradeSettingsStoreACTIONS";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useMemo, useState } from "react";
import useTableUIStore from "@/store/tableUIStore";
import { getFontSizeClass, getButtonSize } from "../../helper/actionSummaryHelper";
import HoverWarningMessage from "../../../../UI/HoverWarningMessage";
import { IToggleButton } from "../../helper/tradeSettingsHelper/tradeSettingsInterfaces";
import { findThisTradeSettings } from "./SelectPanelHelper";
import { doesTradeAtNewContainSWPOrOption } from "./SelectPanelIndex";

interface ISendAsSettings {
  data: any;
}

export function getActiveCounterpartiesCount(esid: string): number {
  const thisTradeSettings = findThisTradeSettings({ esid });
  if (!thisTradeSettings) return 0;
  return thisTradeSettings.counterpartiesList.filter((cp) => cp.active).length;
}

const SendAsSettings = ({ data }: ISendAsSettings) => {
  const esid = data.esid;
  const fontSize = useTableUIStore((state) => state.fontSize);
  const fontSizeClass = getFontSizeClass(fontSize);
  const dynamicButtonSize = getButtonSize(fontSize, "sm");
  const dynamicTopPadding = useMemo(() => {
    const paddingMap = { small: 0, medium: 2, large: 6, "x-large": 10 };
    return paddingMap[fontSize];
  }, [fontSize]);
  const allTradeSettings = tradeSettingsStore(
    (state) => state.tradeSettingsData,
  );
  const { getAccessTokenSilently } = useAuth0();

  const [thisTradeSettings, setThisTradeSettings] = useState(
    findThisTradeSettings({ esid }),
  );

  useEffect(() => {
    setThisTradeSettings(findThisTradeSettings({ esid }));
  }, [allTradeSettings, esid]);

  if (!thisTradeSettings) {
    return null;
  }

  const activeCounterpartiesCount = thisTradeSettings.counterpartiesList.filter(
    (cp) => cp.active,
  ).length;
  const hasMultipleCounterparties = activeCounterpartiesCount > 1;

  const tradeContainsSWPsOrOptionsOrOptions =
    doesTradeAtNewContainSWPOrOption(data);

  return (
    <div
      data-testid="sendAsSettingsContainer"
      className="flex w-full items-center"
      style={{ paddingTop: `${dynamicTopPadding}px` }}
    >
      <div className={`${fontSize === "large" ? "min-w-[70px]" : "min-w-[60px]"} ${fontSizeClass} text-[#404040] dark:text-[#FAFAFA]`}>
        Send as:
      </div>

      <div className="relative flex h-full items-center">
        {thisTradeSettings.tradeTypes.map((type: IToggleButton) => {
          const isOrderButton = type.name === "Order";
          const isDisabled =
            isOrderButton && tradeContainsSWPsOrOptionsOrOptions;
          // const isDisabled = isOrderButton && hasMultipleCounterparties;

          return (
            <HoverWarningMessage
              message="* Orders can only be sent for BND and FUT trades."
              showWhen={isDisabled}
              // buttonText="Clear Selection"
              // onButtonClick={() => clearAllActiveCounterparties({ esid })}
              key={type.name}
            >
              <Button
                key={type.name}
                variantToggle={
                  type.active
                    ? "selectionActive" //: "selectionInactive"
                    : isDisabled
                      ? "selectionDisabled"
                      : "selectionInactive"
                }
                disabled={isDisabled}
                id={type.name}
                className={`${
                  type === thisTradeSettings.tradeTypes[0]
                    ? "rounded-l-md"
                    : type ===
                        thisTradeSettings.tradeTypes[
                          thisTradeSettings.tradeTypes.length - 1
                        ]
                      ? "rounded-r-md"
                      : "border-x"
                }`}
                size={dynamicButtonSize}
                onClick={() => {
                  // if (isDisabled) return;
                  if (type.name == "Order") {
                    if (hasMultipleCounterparties) {
                      clearAllActiveCounterparties({ esid });
                    }

                    const blockData =
                      tradeBlockDataStore.getState().tradeBlockData;
                    const currentBlocks = blockData.find(
                      (block) => block.esid == esid,
                    );

                    if (currentBlocks == undefined) {
                      // Get the Leg data before loading the Leg table.
                      getBlocksData({
                        esid: esid,
                        getAccessTokenSilently: getAccessTokenSilently,
                      });
                    }
                  }

                  setActiveToggle({
                    esid: esid,
                    selectedElement: type,
                    stateVariable: thisTradeSettings.tradeTypes,
                    settingField: "tradeTypes",
                  });
                }}
              >
                {type.name}
              </Button>
            </HoverWarningMessage>
          );
        })}
      </div>
    </div>
  );
};

export default SendAsSettings;
